export class ModalidadeFrete {
    public modalidades =
        [
            { nome: 'CONTRATACAO_POR_CONTA_DO_REMETENTE', codigo: '0', descricao: 'Contratação do frete por conta do remetente (CIF)' },
            { nome: 'CONTRATACAO_POR_CONTA_DO_DESTINATARIO', codigo: '1', descricao: 'Contratação do frete por conta do destinatário (FOB)' },
            { nome: 'CONTRATACAO_POR_CONTA_DE_TERCEIROS', codigo: '2', descricao: 'Contratação do frete por conta de terceiros' },
            { nome: 'PROPRIO_POR_CONTA_DO_REMETENTE', codigo: '3', descricao: 'Transporte próprio por conta do remetente' },
            { nome: 'PROPRIO_POR_CONTA_DO_DESTINATARIO', codigo: '4', descricao: 'Transporte próprio por conta do destinatário' },
            { nome: 'SEM_OCORRENCIA_TRANSPORTE', codigo: '9', descricao: 'Sem ocorrência de transporte' }
        ]
}
